// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import {Controller} from "stimulus"
import noUiSlider from 'nouislider/distribute/nouislider.min'
import wNumb from 'wnumb/wNumb.min'

export default class extends Controller {
  static targets = []

  connect() {
    noUiSlider.create(this.element, {
      start: [0],
      range: {
        'min': [0],
        '25%': [50, 5],
        '50%': [100, 10],
        '75%': [250, 50],
        'max': [500]
      },
      orientation: 'horizontal',
      connect: 'lower',
      tooltips: true,
      format: wNumb({
        decimals: 0
      }),
      pips: {
        mode: 'values',
        values: [0, 50, 100, 250, 500],
        density: 5
      }
    });

    this.element.noUiSlider.on('update', (values) => {
      if (values[0] <= 0) {
        this.display_form0()
      } else if (0 < values[0] && values[0] < 30) {
        this.display_form1()
      } else if (30 <= values[0]) {
        this.display_form2()
      }

      setTimeout(() => {
        if (values[0] <= 0) {
          this.show_form0()
        } else if (0 < values[0] && values[0] < 30) {
          this.show_form1()
        } else if (30 <= values[0]) {
          this.show_form2()
        }
      }, 100)
    })
  }

  display_form0() {
    document.getElementById('form0').classList.remove('d-none')
    document.getElementById('form1').classList.add('d-none')
    document.getElementById('form2').classList.add('d-none')
  }

  show_form0() {
    document.getElementById('form0').classList.add('show')
    document.getElementById('form1').classList.remove('show')
    document.getElementById('form2').classList.remove('show')
  }

  display_form1() {
    document.getElementById('form0').classList.add('d-none')
    document.getElementById('form1').classList.remove('d-none')
    document.getElementById('form2').classList.add('d-none')
  }

  show_form1() {
    document.getElementById('form0').classList.remove('show')
    document.getElementById('form1').classList.add('show')
    document.getElementById('form2').classList.remove('show')
  }

  display_form2() {
    document.getElementById('form0').classList.add('d-none')
    document.getElementById('form1').classList.add('d-none')
    document.getElementById('form2').classList.remove('d-none')
  }

  show_form2() {
    document.getElementById('form0').classList.remove('show')
    document.getElementById('form1').classList.remove('show')
    document.getElementById('form2').classList.add('show')
  }

  disconnect() {
    this.element.noUiSlider.destroy()
  }
}
